import dayjs from 'dayjs'
import { ArrowRightIcon } from 'lucide-react'
import { type FC } from 'react'

import { Button } from '@/components/button/button'
import { Carousel, CarouselContent, CarouselItem } from '@/components/carousel/carousel'
import { Tabs, TabsList, TabsTrigger } from '@/components/tabs/tabs'

import { cn } from '@/lib/utils'

import { VISA_BULLETIN_TABS } from './constants/visa-bulletin-tab'
import { useVisaBulletinInfo } from './hooks/use-visa-bulletin-info'
import { VisaBulletinCard } from './visa-bulletin-card/visa-bulletin-card'

export const VisaBulletinInfo: FC = () => {
  const {
    visaBulletinType,
    currentVisaBulletinData,
    nextVisaBulletinData,
    priorityDate,
    existsVisaBulletinData,
    setCarouselApi,
    handleClickSetVisaBulletinAlertButton,
    handleClickUpdateCaseInfoButton,
    handleClickMoreInfoButton,
    handleChangeTabValue,
  } = useVisaBulletinInfo()

  // Fallback date for the next visa bulletin, calculated as one month after the current bulletin date
  const nextBulletinDateFallback = dayjs
    .tz(nextVisaBulletinData?.bulletinDate, 'YYYY-MM-DD', 'America/New_York')
    .add(1, 'month')
    .format('YYYY-MM-DD')

  return (
    <>
      {!existsVisaBulletinData && (
        <Button
          variant="outline"
          className={cn('h-[56px] w-full', 'py-4')}
          aria-label="Set Visa Bulletin Alert"
          onClick={handleClickSetVisaBulletinAlertButton}
        >
          <span className={cn('mr-auto')}>Set Visa Bulletin Alert</span>
          <ArrowRightIcon size={24} />
        </Button>
      )}
      {existsVisaBulletinData && (
        <>
          <Tabs className={cn('!mb-4 !mt-8')} value={visaBulletinType} onValueChange={handleChangeTabValue}>
            <TabsList>
              {VISA_BULLETIN_TABS.map(({ label, value }) => (
                <TabsTrigger key={value} value={value}>
                  {label}
                </TabsTrigger>
              ))}
            </TabsList>
          </Tabs>
          <Carousel setApi={setCarouselApi} opts={{ watchDrag: false }}>
            <CarouselContent>
              <CarouselItem>
                <VisaBulletinCard
                  bulletinDate={currentVisaBulletinData?.bulletinDate ?? ''}
                  priorityDate={priorityDate ?? ''}
                  finalActionDate={currentVisaBulletinData?.finalActionDate ?? ''}
                  filingDate={currentVisaBulletinData?.filingDate ?? ''}
                  noticeText={currentVisaBulletinData?.noticeText ?? ''}
                  onClickUpdateCaseInfoButton={handleClickUpdateCaseInfoButton}
                  onClickMoreInfoButton={handleClickMoreInfoButton}
                />
              </CarouselItem>
              <CarouselItem>
                <VisaBulletinCard
                  bulletinDate={nextVisaBulletinData?.bulletinDate || nextBulletinDateFallback}
                  priorityDate={priorityDate ?? ''}
                  finalActionDate={nextVisaBulletinData?.finalActionDate ?? ''}
                  filingDate={nextVisaBulletinData?.filingDate ?? ''}
                  noticeText={nextVisaBulletinData?.noticeText ?? ''}
                  onClickUpdateCaseInfoButton={handleClickUpdateCaseInfoButton}
                  onClickMoreInfoButton={handleClickMoreInfoButton}
                />
              </CarouselItem>
            </CarouselContent>
          </Carousel>
        </>
      )}
    </>
  )
}
